<template>
  <div>
    <div v-if="!successData && !pixCodeAndQRCode">
      <QuotePaymentHeader paymentType="pix" />

      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col>
            <v-text-field
              v-model="name"
              :rules="[rules.required]"
              :label="$t('forms.completeName')"
              hide-details="auto"
              outlined
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="document"
              v-mask="
                document.length <= 14 ? mask.cpfCnpj.cpf : mask.cpfCnpj.cnpj
              "
              :rules="[rules.documentCheck]"
              :label="$t('forms.cpfCnpj')"
              hide-details="auto"
              outlined
            />
          </v-col>
        </v-row>

        <QuotePaymentActions @submit="validate" />
      </v-form>
    </div>

    <QuotePaymentPixSuccess
      v-if="successData || pixCodeAndQRCode"
      :pixCodeAndQRCode="pixCodeAndQRCode"
      :successData="successData"
    />
  </div>
</template>

<script>
import QuotePaymentHeader from './QuotePaymentHeader'
import QuotePaymentActions from './QuotePaymentActions'
import QuotePaymentPixSuccess from './QuotePaymentPixSuccess'

import { mapGetters, mapActions } from 'vuex'
import { cpfCnpj, phone } from '@/util/masks'
import { email, required, documentCheck } from '@/util/errorHandling'

export default {
  name: 'QuotePaymentPix',

  components: {
    QuotePaymentHeader,
    QuotePaymentActions,
    QuotePaymentPixSuccess,
  },

  computed: {
    ...mapGetters(['quotes', 'successData']),

    charge() {
      return this.quotes.charge
    },

    pixCodeAndQRCode() {
      if (!this.charge) return false
      if (this.charge?.installments[0]?.payment_method !== 'ASAAS_PIX') return false
      return this.charge
    }
  },

  methods: {
    ...mapActions(['doQuotePayment']),

    validate() {
      if (this.$refs.form.validate()) {
        const document = this.document.replace(/[^0-9]+/g, '')

        const paymentData = {
          payer_name: this.name,
          payer_document: document,
          quote_id: this.quotes.id,
          installment_amount: 1,
          method: 'ASAAS_PIX',
        }

        this.doQuotePayment(paymentData)
      }
    },

    checkChargeStatus() {
      const status = this.quoteItems?.charge?.installments[0]?.status

      status === 'RECEIVED' || status === 'CONFIRMED'
        ? (this.isQuoteAlreadyPaid = true)
        : (this.isQuoteAlreadyPaid = false)

      status === 'PENDING'
        ? (this.isQuotePending = true)
        : (this.isQuotePending = false)
    },
  },

  data() {
    return {
      name: '',
      email: '',
      document: '',

      rules: {
        email,
        required,
        documentCheck,

        min: (val) => (!!val && val.length >= 7) || this.$t('rules.required'),
        name: (val) => (!!val && val.length >= 6) || this.$t('rules.required'),
        number: (val) => (!!val && val.length >= 19) || this.$t('rules.required'),
        expiry: (val) => (!!val && val.length >= 7) || this.$t('rules.required'),
        ccv: (val) => (!!val && val.length >= 2) || this.$t('rules.required'),
      },

      mask: { cpfCnpj, phone },
    }
  },
}
</script>
